type IconName = "cart" | "catalog" | "close" | "moon" | "orders" | "plus" | "refresh" | "search" | "sun" | "trash";

type IconProps = {
  name: IconName;
};

const paths: Record<IconName, string> = {
  cart: "M6 6h15l-2 8H8L6 3H3M9 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM18 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  catalog: "M4 5h6v6H4V5ZM14 5h6v6h-6V5ZM4 15h6v4H4v-4ZM14 15h6v4h-6v-4Z",
  close: "M6 6l12 12M18 6 6 18",
  moon: "M21 14.5A8.5 8.5 0 0 1 9.5 3 7 7 0 1 0 21 14.5Z",
  orders: "M7 4h10l2 3v13H5V7l2-3ZM7 8h10M8 12h8M8 16h5",
  plus: "M12 5v14M5 12h14",
  refresh: "M20 6v5h-5M4 18v-5h5M18.8 11A7 7 0 0 0 7 6.8L4 10M5.2 13A7 7 0 0 0 17 17.2l3-3.2",
  search: "M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15ZM16 16l5 5",
  sun: "M12 5V3M12 21v-2M5 12H3M21 12h-2M6.3 6.3 4.9 4.9M19.1 19.1l-1.4-1.4M17.7 6.3l1.4-1.4M4.9 19.1l1.4-1.4M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  trash: "M5 7h14M10 11v6M14 11v6M9 7l1-2h4l1 2M7 7l1 13h8l1-13",
};

export function Icon({ name }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      className="icon"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={paths[name]} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    </svg>
  );
}
